/**
 * @fileoverview フッターコンポーネント
 *
 * このファイルでは、アプリケーションの共通フッターコンポーネントを定義しています。
 * 著作権情報、リンク、その他のフッターコンテンツを表示します。
 */

/**
 * フッターコンポーネント
 *
 * アプリケーションの下部に表示される共通フッター部分です。
 * 著作権表示、ナビゲーションリンク、法的情報などを含み、
 * すべてのページで一貫した表示を提供します。
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} [props.className] - 追加のCSSクラス名
 * @returns {JSX.Element} フッターコンポーネント
 */
import CopyRights from "./copy-rights";

type Props = {
  className?: string;
};

export default function Footer({ className }: Props) {
  return (
    <footer className={className}>
      <CopyRights />
    </footer>
  );
}
